import {applyMiddleware, createStore, Store} from 'redux'
import {composeWithDevTools} from 'redux-devtools-extension'
import {autoRehydrate, persistStore} from 'redux-persist'
import createSagaMiddleware from 'redux-saga'

import reducer, {IState, persistReducerKeys, transforms} from './reducer'
import saga from './saga'

const sagaMiddleware = createSagaMiddleware()
const store: Store<IState> = createStore(
  reducer,
  composeWithDevTools<IState>(
    applyMiddleware(sagaMiddleware),
    autoRehydrate<IState>(),
  ),
)
sagaMiddleware.run(saga)

persistStore(store, { transforms, whitelist: persistReducerKeys })

export default store
export {IState}
export * from './selectors'
export * from './actionCreators'



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/index.ts